/**
 * The external dependencies.
 */
import React from 'react';
import {connect} from 'react-redux';
/**
 * The internal dependencies.
 */
import {convertToItems} from '../../../../common/utilities';
import InputScrollSelect from '../../../../components/general/input-scroll-select';
import Button from '../../../../components/task/shop/form/button';
import {getTaskWorkplaces} from '../../../../store/tasks/selectors';

const WorkplaceInput = ({
                            data,
                            handleSelect,
                            workplaces,
                            handleComplete,
                        }) => (
    <div>
        <InputScrollSelect
            items={convertToItems(workplaces, data.value)}
            handleChange={handleSelect}
            navHasBorders={false}
            itemsHaveBorders={true}
            button={<Button handleClick={() => handleComplete(data)} width="100%"/>}
        />
    </div>
);

export default connect(
    (state) => ({
        workplaces: getTaskWorkplaces(state),
    })
)(WorkplaceInput);



// WEBPACK FOOTER //
// ./src/components/task/shop/form/workplace-input.js